// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file chat/v3/chat_messages_system.proto (package chat.v3, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v3/chat_messages_system.proto.
 */
export const file_chat_v3_chat_messages_system: GenFile = /*@__PURE__*/
  fileDesc("CiJjaGF0L3YzL2NoYXRfbWVzc2FnZXNfc3lzdGVtLnByb3RvEgdjaGF0LnYzIkIKD01lc3NhZ2VQaW5nRGF0YRIvCgtvY2N1cnJlZF9hdBgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAi5wMKEE1lc3NhZ2VFcnJvckRhdGESFwoPZGlzcGxheV9tZXNzYWdlGAEgASgJEhUKDXN5c3RlbV9kZXRhaWwYAiABKAkSNwoPaW52YWxpZF9yZXF1ZXN0GAMgASgLMhwuY2hhdC52My5JbnZhbGlkUmVxdWVzdEVycm9ySAASNgoOYXV0aGVudGljYXRpb24YBCABKAsyHC5jaGF0LnYzLkF1dGhlbnRpY2F0aW9uRXJyb3JIABIuCgpwZXJtaXNzaW9uGAUgASgLMhguY2hhdC52My5QZXJtaXNzaW9uRXJyb3JIABIrCglub3RfZm91bmQYBiABKAsyFi5jaGF0LnYzLk5vdEZvdW5kRXJyb3JIABI6ChFyZXF1ZXN0X3Rvb19sYXJnZRgHIAEoCzIdLmNoYXQudjMuUmVxdWVzdFRvb0xhcmdlRXJyb3JIABItCgpyYXRlX2xpbWl0GAggASgLMhcuY2hhdC52My5SYXRlTGltaXRFcnJvckgAEiYKCWFwaV9lcnJvchgJIAEoCzIRLmNoYXQudjMuQXBpRXJyb3JIABIuCgpvdmVybG9hZGVkGAogASgLMhguY2hhdC52My5PdmVybG9hZGVkRXJyb3JIAEIMCgplcnJvcl90eXBlSgQICxBlIioKE0ludmFsaWRSZXF1ZXN0RXJyb3ISEwoLc3RhdHVzX2NvZGUYASABKAUiKgoTQXV0aGVudGljYXRpb25FcnJvchITCgtzdGF0dXNfY29kZRgBIAEoBSImCg9QZXJtaXNzaW9uRXJyb3ISEwoLc3RhdHVzX2NvZGUYASABKAUiJAoNTm90Rm91bmRFcnJvchITCgtzdGF0dXNfY29kZRgBIAEoBSIrChRSZXF1ZXN0VG9vTGFyZ2VFcnJvchITCgtzdGF0dXNfY29kZRgBIAEoBSIlCg5SYXRlTGltaXRFcnJvchITCgtzdGF0dXNfY29kZRgBIAEoBSIfCghBcGlFcnJvchITCgtzdGF0dXNfY29kZRgBIAEoBSImCg9PdmVybG9hZGVkRXJyb3ISEwoLc3RhdHVzX2NvZGUYASABKAUiOwoSTWVzc2FnZVdhcm5pbmdEYXRhEg8KB21lc3NhZ2UYASABKAkSDgoGZGV0YWlsGAIgASgJSgQIAxBlIjkKEE1lc3NhZ2VMaW1pdERhdGESDwoHbWVzc2FnZRgBIAEoCRIOCgZkZXRhaWwYAiABKAlKBAgDEGVCV1pVZ2l0aHViLmNvbS9TdG9yeXRlbGwtYWkvc3Rvcnl0ZWxsLWFpLXBsYXRmb3JtL3BrZy9nby9kb21haW5zL2NwL2dlbi9wYi9jaGF0L3YzO2NoYXRWM2IGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * MessagePingData represents the data associated with a heartbeat ping.
 *
 * @generated from message chat.v3.MessagePingData
 */
export type MessagePingData = Message<"chat.v3.MessagePingData"> & {
  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 1;
   */
  occurredAt: Timestamp;
};

/**
 * Describes the message chat.v3.MessagePingData.
 * Use `create(MessagePingDataSchema)` to create a new message.
 */
export const MessagePingDataSchema: GenMessage<MessagePingData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 0);

/**
 * MessageErrorData represents the data associated with an error message.
 *
 * @generated from message chat.v3.MessageErrorData
 */
export type MessageErrorData = Message<"chat.v3.MessageErrorData"> & {
  /**
   * Localized, user friendly error message.
   *
   * @generated from field: string display_message = 1;
   */
  displayMessage: string;

  /**
   * System error message, technical and in English.
   *
   * @generated from field: string system_detail = 2;
   */
  systemDetail: string;

  /**
   * @generated from oneof chat.v3.MessageErrorData.error_type
   */
  errorType: {
    /**
     * @generated from field: chat.v3.InvalidRequestError invalid_request = 3;
     */
    value: InvalidRequestError;
    case: "invalidRequest";
  } | {
    /**
     * @generated from field: chat.v3.AuthenticationError authentication = 4;
     */
    value: AuthenticationError;
    case: "authentication";
  } | {
    /**
     * @generated from field: chat.v3.PermissionError permission = 5;
     */
    value: PermissionError;
    case: "permission";
  } | {
    /**
     * @generated from field: chat.v3.NotFoundError not_found = 6;
     */
    value: NotFoundError;
    case: "notFound";
  } | {
    /**
     * @generated from field: chat.v3.RequestTooLargeError request_too_large = 7;
     */
    value: RequestTooLargeError;
    case: "requestTooLarge";
  } | {
    /**
     * @generated from field: chat.v3.RateLimitError rate_limit = 8;
     */
    value: RateLimitError;
    case: "rateLimit";
  } | {
    /**
     * @generated from field: chat.v3.ApiError api_error = 9;
     */
    value: ApiError;
    case: "apiError";
  } | {
    /**
     * @generated from field: chat.v3.OverloadedError overloaded = 10;
     */
    value: OverloadedError;
    case: "overloaded";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chat.v3.MessageErrorData.
 * Use `create(MessageErrorDataSchema)` to create a new message.
 */
export const MessageErrorDataSchema: GenMessage<MessageErrorData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 1);

/**
 * 400 - Invalid request error
 *
 * @generated from message chat.v3.InvalidRequestError
 */
export type InvalidRequestError = Message<"chat.v3.InvalidRequestError"> & {
  /**
   * Always 400
   *
   * @generated from field: int32 status_code = 1;
   */
  statusCode: number;
};

/**
 * Describes the message chat.v3.InvalidRequestError.
 * Use `create(InvalidRequestErrorSchema)` to create a new message.
 */
export const InvalidRequestErrorSchema: GenMessage<InvalidRequestError> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 2);

/**
 * 401 - Authentication error
 *
 * @generated from message chat.v3.AuthenticationError
 */
export type AuthenticationError = Message<"chat.v3.AuthenticationError"> & {
  /**
   * Always 401
   *
   * @generated from field: int32 status_code = 1;
   */
  statusCode: number;
};

/**
 * Describes the message chat.v3.AuthenticationError.
 * Use `create(AuthenticationErrorSchema)` to create a new message.
 */
export const AuthenticationErrorSchema: GenMessage<AuthenticationError> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 3);

/**
 * 403 - Permission error
 *
 * @generated from message chat.v3.PermissionError
 */
export type PermissionError = Message<"chat.v3.PermissionError"> & {
  /**
   * Always 403
   *
   * @generated from field: int32 status_code = 1;
   */
  statusCode: number;
};

/**
 * Describes the message chat.v3.PermissionError.
 * Use `create(PermissionErrorSchema)` to create a new message.
 */
export const PermissionErrorSchema: GenMessage<PermissionError> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 4);

/**
 * 404 - Not found error
 *
 * @generated from message chat.v3.NotFoundError
 */
export type NotFoundError = Message<"chat.v3.NotFoundError"> & {
  /**
   * Always 404
   *
   * @generated from field: int32 status_code = 1;
   */
  statusCode: number;
};

/**
 * Describes the message chat.v3.NotFoundError.
 * Use `create(NotFoundErrorSchema)` to create a new message.
 */
export const NotFoundErrorSchema: GenMessage<NotFoundError> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 5);

/**
 * 413 - Request too large error
 *
 * @generated from message chat.v3.RequestTooLargeError
 */
export type RequestTooLargeError = Message<"chat.v3.RequestTooLargeError"> & {
  /**
   * Always 413
   *
   * @generated from field: int32 status_code = 1;
   */
  statusCode: number;
};

/**
 * Describes the message chat.v3.RequestTooLargeError.
 * Use `create(RequestTooLargeErrorSchema)` to create a new message.
 */
export const RequestTooLargeErrorSchema: GenMessage<RequestTooLargeError> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 6);

/**
 * 429 - Rate limit error
 *
 * @generated from message chat.v3.RateLimitError
 */
export type RateLimitError = Message<"chat.v3.RateLimitError"> & {
  /**
   * Always 429
   *
   * @generated from field: int32 status_code = 1;
   */
  statusCode: number;
};

/**
 * Describes the message chat.v3.RateLimitError.
 * Use `create(RateLimitErrorSchema)` to create a new message.
 */
export const RateLimitErrorSchema: GenMessage<RateLimitError> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 7);

/**
 * 500 - API error
 *
 * @generated from message chat.v3.ApiError
 */
export type ApiError = Message<"chat.v3.ApiError"> & {
  /**
   * Always 500
   *
   * @generated from field: int32 status_code = 1;
   */
  statusCode: number;
};

/**
 * Describes the message chat.v3.ApiError.
 * Use `create(ApiErrorSchema)` to create a new message.
 */
export const ApiErrorSchema: GenMessage<ApiError> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 8);

/**
 * 529 - Overloaded error
 *
 * @generated from message chat.v3.OverloadedError
 */
export type OverloadedError = Message<"chat.v3.OverloadedError"> & {
  /**
   * Always 529
   *
   * @generated from field: int32 status_code = 1;
   */
  statusCode: number;
};

/**
 * Describes the message chat.v3.OverloadedError.
 * Use `create(OverloadedErrorSchema)` to create a new message.
 */
export const OverloadedErrorSchema: GenMessage<OverloadedError> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 9);

/**
 * MessageWarningData represents the data associated with a warning message.
 *
 * @generated from message chat.v3.MessageWarningData
 */
export type MessageWarningData = Message<"chat.v3.MessageWarningData"> & {
  /**
   * Localized, user friendly warning message.
   *
   * @generated from field: string message = 1;
   */
  message: string;

  /**
   * System warning message, technical and in English.
   *
   * @generated from field: string detail = 2;
   */
  detail: string;
};

/**
 * Describes the message chat.v3.MessageWarningData.
 * Use `create(MessageWarningDataSchema)` to create a new message.
 */
export const MessageWarningDataSchema: GenMessage<MessageWarningData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 10);

/**
 * @generated from message chat.v3.MessageLimitData
 */
export type MessageLimitData = Message<"chat.v3.MessageLimitData"> & {
  /**
   * Localized, user friendly limit message.
   *
   * @generated from field: string message = 1;
   */
  message: string;

  /**
   * System limit message, technical and in English.
   *
   * @generated from field: string detail = 2;
   */
  detail: string;
};

/**
 * Describes the message chat.v3.MessageLimitData.
 * Use `create(MessageLimitDataSchema)` to create a new message.
 */
export const MessageLimitDataSchema: GenMessage<MessageLimitData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages_system, 11);

